import React from 'react';
import PropTypes from 'prop-types';
import {compose, graphql} from 'react-apollo';
import Loading from "components/Loading";
import CreateAdvert from "./CreateAdvert";
import {injectIntl, defineMessages} from "react-intl";

import DataQuery from 'gql/contactList.gql';
import EnumsQuery from 'gql/advert/enums.gql';
import AdvertCreateMutation from 'gql/advert/create.gql';
import OperatorQuery from 'gql/operator/operator.gql';
import {withUser} from "helpers/login";
import {connect} from "react-redux";
import {openModal} from "../../actions/modal";
import {withRouter} from "react-router";

const messages = defineMessages({
    no_sms: {
        id: 'priceLevels.no_sms',
        defaultMessage: 'I don\'t want to receive SMS'
    }
});

class InitialAdvertCreator extends React.Component {
    static propTypes = {
        children: PropTypes.any.isRequired,
        operatorQuery: PropTypes.object.isRequired,
        dataQuery: PropTypes.object,
        enumsQuery: PropTypes.object,
        createAdvert: PropTypes.func.isRequired,
        intl: PropTypes.object.isRequired,
        onLogout: PropTypes.func.isRequired,
        openFirstAdvertCreatedModal: PropTypes.func.isRequired
    };

    createAdvert(model) {
        return this.props.createAdvert({
            variables: {
                advert: {
                    operatorId: this.props.operatorQuery.operator.id,
                    nickname: model.name,
                    heading: model.title,
                    text: model.text,
                    priceLevelVoiceId: model.callPrice,
                    priceLevelTextId: model.smsPrice,
                    photo: model.photoUrl,
                    serviceTypes: model.serviceTypes,
                    adHappyHours: model.happyHours,
                }
            },
            update: (store, {data: {advert}}) => {
                const query = DataQuery;
                const variables = {
                    operator: this.props.operatorQuery.operator ? this.props.operatorQuery.operator.id : null,
                    contactOffset: 0,
                    contactLimit: 1,
                    profileLimit: 10,
                    profileOffset: 0
                };

                const data = store.readQuery({query, variables});
                data.adverts.push(Object.assign({profiles: [], numUnreadProfiles: 0, numProfiles: 0}, advert));
                store.writeQuery({query, variables, data});

                const operatorData = store.readQuery({query: OperatorQuery});
                operatorData.operator.publicNumbers.countAssigned++;
                store.writeQuery({query: OperatorQuery, data: operatorData});
            }
        }).then(() => {
            this.props.openFirstAdvertCreatedModal();
        });
    }

    render() {
        const {dataQuery, intl, enumsQuery, operatorQuery, onLogout} = this.props;

        if (operatorQuery.operator && !dataQuery.adverts) {
            return (<Loading/>);
        }

        if (dataQuery && dataQuery.adverts.length === 0) {
            const serviceTypes = (enumsQuery && enumsQuery.serviceTypes)
                ? enumsQuery.serviceTypes.map(type => ({name: type.name, value: type.key}))
                : [];
            const priceLevelsVoice = (enumsQuery && enumsQuery.availablePriceLevelsVoice)
                ? enumsQuery.availablePriceLevelsVoice.map(level => ({
                    name: level.description,
                    value: level.id.toString(10)
                }))
                : [];
            const priceLevelsSms = (enumsQuery && enumsQuery.availablePriceLevelsSms)
                ? enumsQuery.availablePriceLevelsSms.map(level => ({
                    name: level.description,
                    value: level.id.toString(10)
                }))
                : [];

            const priceValuesVoice = priceLevelsVoice.slice(0);
            priceValuesVoice.unshift({name: '', value: ''});

            const priceValuesSms = priceLevelsSms.slice(0);
            priceValuesSms.unshift({
                name: intl.formatMessage(messages.no_sms),
                value: ''
            });

            return (<CreateAdvert serviceTypeValues={serviceTypes} onAdvertFormSubmit={::this.createAdvert}
                                  priceValuesVoice={priceValuesVoice} priceValuesSms={priceValuesSms} onLogout={onLogout}
                                  canHaveHappyHours={operatorQuery.operator.happyHoursPermitted}
            />);
        }

        return this.props.children;
    }
}

export default compose(
    withRouter,
    injectIntl,
    withUser,
    connect(
        state => ({

        }),
        dispatch => ({
            openFirstAdvertCreatedModal: () => dispatch(openModal('firstAdvertCreated'))
        })
    ),
    graphql(OperatorQuery, {
        name: 'operatorQuery',
        options: {
            fetchPolicy: 'cache-only',
        }
    }),
    graphql(DataQuery, {
        name: 'dataQuery',
        options: props => ({
            skip: !props.operatorQuery || !props.operatorQuery.operator,
            variables: {
                operator: props.operatorQuery.operator ? parseInt(props.operatorQuery.operator.id, 10) : null,
                contactLimit: 1,
                contactOffset: 0,
                profileLimit: 10,
                profileOffset: 0,
            },
            fetchPolicy: 'cache-only'
        }),
    }),
    graphql(EnumsQuery, {
        name: 'enumsQuery',
        options: props => ({
            skip: !props.user,
            fetchPolicy: 'cache-first',
        })
    }),
    graphql(AdvertCreateMutation, {name: 'createAdvert'}),
)(InitialAdvertCreator);


// WEBPACK FOOTER //
// ./src/containers/InitialAdvertCreator/index.jsx